// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { ChevronLeft as RawChevronLeft } from "lucide-react";
export const ChevronLeft = /* @__PURE__ */ createIcon(RawChevronLeft, "ChevronLeft", 2);
